<div #overlayFader class="overlay-fader"></div>

@if (currentOverlay().image) {
  <img class="overlay-background-image"
       [src]="environment.bucketUrlImages + currentOverlay().image"
       alt="overlay background">
}

@for (item of currentOverlay().items; track item.id) {
  <div #overlayItem [id]="item.id"
       class="overlay-item"
       [class.clickable]="item.videoId || item.section || item.link"
       [ngClass]="'align-' + ((item.title ? item.title.align : item.align) ?? 'center')"
       [style.top.%]="item.posY"
       [style.left.%]="item.posX"
  >
    @if (item.image || item.img) {
      <img class="overlay-item-image"
           [src]="environment.bucketUrlImages + (item.img ?? item.image.img)"
           alt="poi">
    }

    @if (item.title || item.text) {
      <span class="overlay-item-title" [ngClass]="item.type ?? item.title.type">
        {{ item.text ?? item.title.text }}
      </span>
    }
  </div>
}